module.exports = __webpack_public_path__ + "img/footer_logo.b8d2e270.svg";